import { render, staticRenderFns } from "./Nazikin.vue?vue&type=template&id=95896ad8&scoped=true"
import script from "./Nazikin.vue?vue&type=script&lang=js"
export * from "./Nazikin.vue?vue&type=script&lang=js"
import style0 from "./Nazikin.vue?vue&type=style&index=0&id=95896ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95896ad8",
  null
  
)

export default component.exports